module.exports = __webpack_public_path__ + "img/menu_teamvertreter.31c7e28a.png";